export default {
  "title": {
    "evolution": "Fatigue evolution",
    "biocompatibilityIndex": "Biocompatibility index",
    "indicators": "Main indicators",
    "workshifts": "Working shift",
    "alertCurve": "Alert curve"
  },
  "help": {
    "workshifts": "It allows to visualize every registered shift in the interval dates selected at the upper part of the screen (it will only show a 14-day maximum), The shifts may be composed by different types of activities described in the legend of this graph.",
    "alertCurve": "It allows users to visualize the different alert levels, fatigue and somnolence during the period of dates selected in the upper part of the screen (it will only show a maximum of 14 days). Through this report you will be able to identify the moments of exposure to somnolence and critical fatigue.",
    "events": "Drowsiness Event: The driver shows signs of fatigue or drowsiness. They are in a state where fatigue has an adverse effect on their ability to concentrate on the driving task."
  },
  "buttons": {
    "moreDetails": "more details",
    "changeView": "change view"
  },
  "graphToolTip": {
    "indice": "Fatigue rate",
    "activity": "Activity",
    "alertLevel": "Alert level",
    "event": "Event",
    "hour": "Time",
    "duration": "Duration",
    "start": "Beginning",
    "end": "End",
    "place": "Place"
  },
  "graphEventsLabels": {
    "driving": "Driving",
    "detention": "Stoppage",
    "base": "Base",
    "client": "Client"
  },
  "graphAlertStateLabels": {
    "a1": "Very alert",
    "a2": "Alert",
    "a3": "Normal",
    "a4": "Slight drowsiness",
    "a5": "Drowsiness",
    "a6": "Very fatigued",
    "a7": "Extremely fatigued",
    "aSleep": "Sleeping",
    "roadWarning": "Drowsiness",
    "sleepPeriods": "Sleep periods",
    "featuredSleepPeriods": "Featured sleep periods",
    "day": "DAY",
    "analysis": "ANALYSIS",
    "hours": "HOURS",
    "events": "EVENTS"
  },
  "ibcToolTip": {
    "labelText": "Indicator that allows identifying how risky the driver's shift structure is. For this, the start and end times of work during the last 14 days are processed and this index is delivered, which ranges between 0 and 100, where 0 is not fatigued and 100 is extremely fatigued.",
    "outOfRisk": "Low risk",
    "middleRisk": "Medium risk",
    "to": "to",
    "higherRisk": "High risk"
  }
};


// WEBPACK FOOTER //
// ./source/client/components/locales/language_configuration/english/fatigue/driverFatigue.js